import React, { useEffect, useState } from 'react';
import {
	getActebi,
	getActebiCategory,
	getSubCategory,
	getSubCategorySlug,
	getYears,
} from '../service/service';
import pdf from '../images/collection-pdf.png';

export default function SakrebuloActs({ actsSlug, subSlug }) {
	const [years, setYears] = useState([]);
	const [angarishebi, setAngarishebi] = useState([]);
	const [selectedYear, setSelectedYear] = useState(null);
	const [category, setCategory] = useState([]);
	const [acts, setActs] = useState([]);
	const [loading, setLoading] = useState(false);
	const [subActs, setSubacts] = useState([]);

	useEffect(() => {
		if (actsSlug) {
			const getCategory = async () => {
				await getActebiCategory().then(data => {
					setCategory(data);
				});
			};
			getCategory();
		}
	}, [actsSlug]);

	useEffect(() => {
		if (subSlug) {
			const getCategory = async () => {
				await getSubCategory().then(data => {
					setCategory(data);
				});
			};
			getCategory();
		}
	}, [subSlug]);

	useEffect(() => {
		if (category) {
			const categoryFilter = category.filter(
				item => item.slug === actsSlug || item.slug === subSlug
			);
			setActs(categoryFilter[0]?.title);
		}
	}, [category, actsSlug, subSlug]);

	//wen click
	const handleYearClick = async (title, year) => {
		if (subSlug) {
			const angarishebi = await getSubCategorySlug(title, year);
			setAngarishebi(angarishebi);
			setSelectedYear(year);
		}
		if (actsSlug) {
			const angarishebi = await getActebi(title, year);
			setAngarishebi(angarishebi);
			setSelectedYear(year);
		}
	};

	const getYearsFc = async () => {
		const years = await getYears();
		setYears(years);
	};

	useEffect(() => {
		getYearsFc();
	}, []);

	useEffect(() => {
		if (subSlug && years.length > 0 && acts) {
			const angarishebi = async () => {
				const data = await getSubCategorySlug(acts, years[0].year);
				setAngarishebi(data);
				setLoading(true);
				if (years && acts) {
					setSelectedYear(years[0].year);
				}
			};
			angarishebi();
		}
	}, [acts, subActs, years]);

	useEffect(() => {
		if (actsSlug && years.length > 0 && acts) {
			const angarishebi = async () => {
				try {
					const item = await getActebi(acts, years[0].year);
					setAngarishebi(item);
					setLoading(true);
					setSelectedYear(years[0].year);
				} catch (err) {
					console.error('getActebi error:', err);
				}
			};
			angarishebi();
		}
	}, [acts, actsSlug, years]);

	return (
		<>
			<ul className='years--filter__container'>
				{years?.map(year => (
					<li
						key={year.id}
						onClick={() => handleYearClick(acts, year.year)}
						className={year.year === selectedYear ? 'active' : ''}
					>
						{year.year}
					</li>
				))}
			</ul>
			{angarishebi ? (
				angarishebi?.map(item => (
					<div key={item.id} className='angarishebi-item'>
						<a href={item.file} target='blank'>
							<span>{item.title}</span>
							<img src={pdf} alt='' />
						</a>
					</div>
				))
			) : (
				<h1>Loading....</h1>
			)}
		</>
	);
}
